import { createFileRoute } from '@tanstack/react-router';

import { SparePartSheet } from '../../components/SparePartSheet/SparePartSheet';

export const Route = createFileRoute('/_auth/spare-part-sheet/')({
  component: SparePartSheet,
});
